import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-16">
          <SectionHeading
            eyebrow="常见问题"
            title="关于这份片单，你可能想知道的"
            desc="这里回答了关于片单内容、搜索筛选、榜单更新等常见疑问。点开任意一条即可查看说明。"
          />

          <div className="space-y-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="rounded-lg border border-background-200/80 bg-background-50 overflow-hidden"
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-label text-sm md:text-base font-medium text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-500"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen ? (
                    <div className="px-4 md:px-5 pb-4 -mt-1">
                      <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200/80 pt-4">
                        {item.a}
                      </p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}